(() => {
  const CLOSE_MS = 220;
  const MENU_SELECTOR = '.lamseti-mega-header .kh-mobile-menu';
  const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const finishClose = (menu, restoreFocus) => {
    menu.open = false;
    menu.classList.remove('is-closing');
    menu.setAttribute('aria-expanded', 'false');

    if (!document.querySelector(`${MENU_SELECTOR}[open]`)) {
      document.body.classList.remove('lamseti-mobile-menu-open');
    }

    if (restoreFocus) {
      menu.querySelector(':scope > summary')?.focus({ preventScroll: true });
    }
  };

  const closeMenu = (menu, { restoreFocus = false } = {}) => {
    if (!menu?.open || menu.classList.contains('is-closing')) return;

    if (reduceMotion()) {
      finishClose(menu, restoreFocus);
      return;
    }

    menu.classList.add('is-closing');
    window.setTimeout(() => finishClose(menu, restoreFocus), CLOSE_MS);
  };

  document.addEventListener('click', (event) => {
    const summary = event.target instanceof Element
      ? event.target.closest('.lamseti-mega-header .kh-mobile-menu > summary')
      : null;
    const menu = summary?.closest('.kh-mobile-menu');

    if (!summary || !menu?.open) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    closeMenu(menu, { restoreFocus: true });
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    const menu = document.querySelector(`${MENU_SELECTOR}[open]`);
    if (!menu) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    closeMenu(menu, { restoreFocus: true });
  }, true);

  document.addEventListener('pointerdown', (event) => {
    const menu = document.querySelector(`${MENU_SELECTOR}[open]`);
    if (!menu || menu.classList.contains('is-closing')) return;

    const target = event.target;
    if (!(target instanceof Node)) return;

    const panel = menu.querySelector('.kh-mobile-panel');
    const summary = menu.querySelector(':scope > summary');
    if (panel?.contains(target) || summary?.contains(target)) return;

    event.stopImmediatePropagation();
    closeMenu(menu);
  }, true);

  document.addEventListener('shopify:section:unload', (event) => {
    event.target?.querySelectorAll?.('.kh-mobile-menu.is-closing').forEach((menu) => {
      menu.classList.remove('is-closing');
    });
  });
})();
